import React, { useEffect, useRef, useState } from 'react';
import './Cat.css';

const FRAME_WIDTH = 60; // ширина одного кадру
const FRAME_HEIGHT = 60; // висота одного кадру
const FRAME_COUNT = 6; // кількість кадрів у спрайті

export default function Cat() {
  const [frame, setFrame] = useState(0);
  const ticking = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!ticking.current) {
        window.requestAnimationFrame(() => {
          const scrollTop = window.scrollY;
          const frameIndex = Math.floor((scrollTop / 10) % FRAME_COUNT);
          setFrame(frameIndex);
          ticking.current = false;
        });
        ticking.current = true;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="fixed">
      <div
        style={{
          width: `${FRAME_WIDTH}px`,
          height: `${FRAME_HEIGHT}px`,
          backgroundImage: 'url(/cat-sprite.png)', // заміни на актуальний шлях
          backgroundPosition: `0px -${frame * FRAME_WIDTH}px`,
          // backgroundPosition: `-${frame * FRAME_WIDTH}px 0px`,
          backgroundSize: `${FRAME_HEIGHT}px ${FRAME_WIDTH * FRAME_COUNT}px`,
          // backgroundSize: `${FRAME_WIDTH * FRAME_COUNT}px ${FRAME_HEIGHT}px`,
          imageRendering: 'pixelated',
        }}
      />
    </div>
  );
}
